import { patchAutoComplete } from './autocomplete'
import { patchAutoFocus } from './autofocus'
import { patchConnectedOverlayScroll } from './connected-overlay-scroll'
import { patchDialog } from './dialog'
import { patchDialogFocus } from './dialog-focus'
import { patchMenu } from './menu'
import { patchMultiSelect } from './multiselect'
import { patchOverlay } from './overlay'
import { patchOverlayInsets } from './overlay-insets'
import { patchPopover } from './popover'
import { patchSelect } from './select'
import { patchTieredMenu } from './tiered-menu'

export function applyPrimeNgOverrides() {
  patchAutoComplete()
  patchAutoFocus()
  patchConnectedOverlayScroll()
  patchDialog()
  patchDialogFocus()
  patchMenu()
  patchMultiSelect()
  patchOverlay()
  patchOverlayInsets()
  patchPopover()
  patchSelect()
  patchTieredMenu()
}
